module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table-run', {
    staticClass: "no-selectable-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "option-buttons": _vm.optionButtons,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-options": true,
      "include-settings": true,
      "selectable": false
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent,
      "on-search-event": _vm.searchByColumn,
      "on-delete-event": _vm.deleteRow,
      "go-to-edit-page": _vm.goToEdit,
      "custom-button": _vm.customButton
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.numReservation))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.booking_state))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.customer.data.name) + " " + _vm._s(props.row.customer.data.lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.country))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getChannelData(props.row)))]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(props.row.codeRoomtype))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getRoomCode(props.row)))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.bookingStart, 'DD/MM/YYYY HH:mm:ss')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.numberNights))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.bookingEnd, 'DD/MM/YYYY HH:mm:ss')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.employee_name))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm._f("round")(props.row.total)))]), _vm._v(" "), _c('td', {
          style: (_vm.getRightColor(props.row))
        }, [_vm._v(_vm._s(_vm.getPaymentStatus(props.row)))])]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right mt-3"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.totalPages,
      "total-visible": _vm.pagesVisible
    },
    on: {
      "input": _vm.currentPage
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1), _vm._v(" "), _c('menu-list', {
    attrs: {
      "position-x": _vm.x,
      "position-y": _vm.y,
      "reservation": _vm.currentRow,
      "menu-list": _vm.filteredMenuList,
      "subsidiary-id": _vm.subsidiaryId
    },
    on: {
      "no-show": _vm.noShowBooking,
      "visualize-book": _vm.seeBook,
      "open-cancel-modal": _vm.openCancelBookingModal
    },
    model: {
      value: (_vm.showMenu),
      callback: function($$v) {
        _vm.showMenu = $$v
      },
      expression: "showMenu"
    }
  }), _vm._v(" "), _c('menu-visualize', {
    attrs: {
      "model": _vm.currentRow
    },
    on: {
      "close-modal": function($event) {
        _vm.closeModal('modalSeeBooking')
      }
    },
    model: {
      value: (_vm.modalSeeBooking),
      callback: function($$v) {
        _vm.modalSeeBooking = $$v
      },
      expression: "modalSeeBooking"
    }
  }), _vm._v(" "), _c('menu-no-show', {
    attrs: {
      "model": _vm.currentRow
    },
    on: {
      "close-modal": function($event) {
        _vm.closeModal('openNoShowModal')
      }
    },
    model: {
      value: (_vm.openNoShowModal),
      callback: function($$v) {
        _vm.openNoShowModal = $$v
      },
      expression: "openNoShowModal"
    }
  }), _vm._v(" "), _c('menu-cancel-booking', {
    attrs: {
      "booking-code": _vm.currentRow.code
    },
    on: {
      "close-cancel-modal": _vm.closeCancelModal,
      "updated-booking-status": _vm.bookingStatusUpdated
    },
    model: {
      value: (_vm.openCancelModal),
      callback: function($$v) {
        _vm.openCancelModal = $$v
      },
      expression: "openCancelModal"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe2d6032","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/bookings/sub-component/booking-table.vue
// module id = 1705
// module chunks = 21